import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type {
  AdminListProjectPostsParams,
  AdminDeleteProjectPostParams,
  AdminAuditPostInput,
} from '../api'
import { adminListProjectPostsOptions } from './admin-post.options'
import postService from './admin-post.service'
import type { IMutationArgs } from '../types'
import { EAdminPostQueryKey } from './admin-post.types'

export const useAdminListProjectPosts = (
  params: AdminListProjectPostsParams,
) => {
  return useQuery(adminListProjectPostsOptions(params))
}

export const useAdminDeleteProjectPost = (args?: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args || {}

  return useMutation({
    mutationFn: (data: AdminDeleteProjectPostParams) =>
      postService.adminDeleteProjectPost(data),
    onSuccess: (data) => {
      if (invalidate) {
        queryClient.invalidateQueries({
          queryKey: [EAdminPostQueryKey.ADMIN_LIST_PROJECT_POSTS],
        })
      }
      return data
    },
  })
}

export const useAdminAuditProjectPost = (args?: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args || {}

  return useMutation({
    mutationFn: (data: AdminAuditPostInput) =>
      postService.adminAuditProjectPost(data),
    onSuccess: (data) => {
      if (invalidate) {
        queryClient.invalidateQueries({
          queryKey: [EAdminPostQueryKey.ADMIN_LIST_PROJECT_POSTS],
        })
      }
      return data
    },
  })
}
